// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"93708830","977":"daab9a9f"}[chunkId] + ".chunk.js";
};